import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { Page } from "@tenant/ui";
import clsx from "clsx";
import type { PageComponentProps } from "../Page";
import defaultStyles from "./TripsAppPage.module.scss";

interface TripsAppPageProps extends PageComponentProps {
  contentClassName?: string;
}

export const TripsAppPage = ({
  children,
  contentClassName,
  ...props
}: TripsAppPageProps) => {
  const styles = useUiStyles(CoreUiComponents.TripsAppPage, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.TripsAppPage);

  return (
    <Page {...props}>
      <div className={block}>
        <div className={clsx(cn("content"), contentClassName)}>{children}</div>
      </div>
    </Page>
  );
};
